import {Fragment} from "react";
import {useDispatch} from "react-redux";
import {Box} from "@mui/system";
import _ from "lodash";
import {screenshotActions, utilityActions} from "_actions";
import useViewMessageDetails from "../../../../Utilities/hooks/useViewMessageDetails";
import {buildPositiveFeedbackPayload} from "../FeedbackUtils";
import {SnackBar} from "../../../../../../../../common";
import ActionButton from "../../../../../../../common/ActionButton";

export default function PositiveFeedbackModalContainer({handleClose}) {
    const { message } = useViewMessageDetails();
    const dispatch = useDispatch();

    const handleSubmit = () => {
        if(_.isEmpty(_.get(message, 'agent'))) {
            SnackBar.showMessage("No expert found");
            return;
        }
        const currentPath = utilityActions.getCurrentPath();
        const currPath = currentPath ? currentPath : "/screenshots";
        const payload = buildPositiveFeedbackPayload(message);
        if(!payload) {
            return;
        }
        dispatch(screenshotActions.addScreenshot(payload, currPath));
        handleClose();
    }

    return(
        <Fragment>
            <Box sx={{marginTop: '-8px'}}>
                <Box sx={styles.heading}>
                    Please confirm to send auto-generated positive feedback to the expert
                </Box>

                <Box sx={styles.actionsContainer}>
                    <Box sx={styles.buttonContainer}>
                        <ActionButton
                            label={'Cancel'}
                            action={handleClose}
                            buttonBordered
                            useBorderColor={'#07857C'}
                            withIcon={false}
                            sx={styles.cancel}
                        />
                        <ActionButton
                            label={'Send'}
                            action={handleSubmit}
                            withIcon={false}
                            sx={styles.submitReason}
                        />
                    </Box>
                </Box>
            </Box>
        </Fragment>
    )
}

const styles = {
    heading: {
        fontFamily: 'LarsseitRegular',
        fontSize: '16px',
        color: '#0C2728',
        letterSpacing: '-0.01em',
        marginBottom: '12px'
    },
    buttonContainer: {
        display: 'flex',
    },
    cancel: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '8px'
    },
    submitReason: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionsContainer: {
        display: 'flex',
        marginTop: '27px',
        justifyContent: 'flex-end',
    }
}